import { Accordion } from "ui/accordion";

import {
  PreviewSidebarItemsType,
  PreviewSidebarItemType,
} from "containers/admin/clients/client/theme-page/preview/preview-sidebar/preview-sidebar.types";

const PreviewSidebar = ({
  sidebarItems,
  isAccordionApplied = false,
  sidebarInfoWarning,
}: PreviewSidebarItemsType) => {
  return (
    <div className="flex flex-col h-full w-[320px] border-r border-zinc-200 overflow-y-auto custom-scroll py-5 pr-6 pl-8 gap-5">
      {sidebarInfoWarning}
      {sidebarItems.map((el: PreviewSidebarItemType, ind: number) =>
        isAccordionApplied ? (
          <Accordion
            key={el.titleText + ind}
            title={el.titleText}
            defaultExpanded={el.isOpen}>
            {el.children}
          </Accordion>
        ) : (
          <div key={ind + el.titleText}>
            <span className="font-semibold tracking-widest text-gray-500">{el.titleText}</span>
            <div className="mt-2">{el.children}</div>
          </div>
        ),
      )}
    </div>
  );
};

export default PreviewSidebar;
